import ListItemButton from "@mui/material/ListItemButton";
import { usePathname } from "../hooks/usePathname";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { useRouter } from "../hooks/useRouter";

interface NavItemBody {
  item: {
    title: string;
    path: string;
    icon: JSX.Element;
  };
}

function NavItem({ item }: NavItemBody) {
  const pathname = usePathname();
  const router = useRouter();
  const active = pathname.includes(item.path);

  return (
    <ListItemButton
      onClick={() => {
        router.push(item.path);
      }}
      sx={{
        minHeight: 44,
        borderRadius: 0.75,
        typography: "body2",
        color: "text.secondary",
        textTransform: "capitalize",
        fontWeight: "fontWeightMedium",
        ...(active && {
          color: "primary.main",
          fontWeight: "fontWeightSemiBold",
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
          "&:hover": {
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
          },
        }),
      }}
    >
      <Box component="span" sx={{ width: 24, height: 24, mr: 2 }}>
        {item.icon}
      </Box>

      <Box component="span">{item.title} </Box>
    </ListItemButton>
  );
}

export default NavItem;
